export default "__VITE_ASSET__bbd183b8__"